// Trabalhe Conosco Page JavaScript
document.addEventListener('DOMContentLoaded', function() {
    modal();

    const form = document.querySelector('.application-form__fields');
    const fileInput = document.getElementById('curriculum');
    const submitButton = document.querySelector('.application-form__submit');

    if (form) {
        // File validation
        fileInput.addEventListener('change', function(e) {
            const file = e.target.files[0];
            const maxSize = 5 * 1024 * 1024; // 5MB
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

            if (file) {
                // Check file size
                if (file.size > maxSize) {
                    alert('O arquivo é muito grande. O tamanho máximo permitido é 5MB.');
                    fileInput.value = '';
                    return;
                }

                // Check file type
                if (!allowedTypes.includes(file.type)) {
                    alert('Formato de arquivo não suportado. Use apenas PDF, DOC ou DOCX.');
                    fileInput.value = '';
                    return;
                }

                // Show selected file name
                const fileName = file.name;
                const fileLabel = fileInput.nextElementSibling;
                if (fileLabel && fileLabel.classList.contains('form-help')) {
                    fileLabel.textContent = `Arquivo selecionado: ${fileName}`;
                    fileLabel.style.color = '#d9bf80';
                }
            }
        });

        // Form validation and submission
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            // Basic validation
            const requiredFields = form.querySelectorAll('[required]');
            let isValid = true;

            requiredFields.forEach(field => {
                if (field.type === 'checkbox') {
                    if (!field.checked) {
                        isValid = false;
                        const checkboxLabel = field.closest('.checkbox-label');
                        if (checkboxLabel) {
                            checkboxLabel.style.color = '#dc3545';
                        }
                    } else {
                        const checkboxLabel = field.closest('.checkbox-label');
                        if (checkboxLabel) {
                            checkboxLabel.style.color = '#666';
                        }
                    }
                } else if (!field.value.trim()) {
                    isValid = false;
                    field.style.borderColor = '#dc3545';

                    // Add error message
                    let errorMsg = field.parentNode.querySelector('.error-message');
                    if (!errorMsg) {
                        errorMsg = document.createElement('small');
                        errorMsg.className = 'error-message';
                        errorMsg.style.color = '#dc3545';
                        errorMsg.style.fontSize = '0.85rem';
                        errorMsg.style.marginTop = '4px';
                        field.parentNode.appendChild(errorMsg);
                    }
                    errorMsg.textContent = 'Este campo é obrigatório.';
                } else {
                    field.style.borderColor = '#e1e5e9';
                    const errorMsg = field.parentNode.querySelector('.error-message');
                    if (errorMsg) {
                        errorMsg.remove();
                    }
                }
            });

            // Email validation
            const emailField = document.getElementById('email');
            if (emailField && emailField.value) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(emailField.value)) {
                    isValid = false;
                    emailField.style.borderColor = '#dc3545';

                    let errorMsg = emailField.parentNode.querySelector('.error-message');
                    if (!errorMsg) {
                        errorMsg = document.createElement('small');
                        errorMsg.className = 'error-message';
                        errorMsg.style.color = '#dc3545';
                        errorMsg.style.fontSize = '0.85rem';
                        errorMsg.style.marginTop = '4px';
                        emailField.parentNode.appendChild(errorMsg);
                    }
                    errorMsg.textContent = 'Digite um e-mail válido.';
                }
            }

            // Phone validation
            const phoneField = document.getElementById('phone');
            if (phoneField && phoneField.value) {
                const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
                const cleanPhone = phoneField.value.replace(/\D/g, '');
                if (!phoneRegex.test(cleanPhone) || cleanPhone.length < 10) {
                    isValid = false;
                    phoneField.style.borderColor = '#dc3545';

                    let errorMsg = phoneField.parentNode.querySelector('.error-message');
                    if (!errorMsg) {
                        errorMsg = document.createElement('small');
                        errorMsg.className = 'error-message';
                        errorMsg.style.color = '#dc3545';
                        errorMsg.style.fontSize = '0.85rem';
                        errorMsg.style.marginTop = '4px';
                        phoneField.parentNode.appendChild(errorMsg);
                    }
                    errorMsg.textContent = 'Digite um telefone válido.';
                }
            }

            if (!isValid) {
                return;
            }

            // Show loading state
            submitButton.disabled = true;
            submitButton.textContent = 'Enviando...';
            submitButton.style.opacity = '0.7';

            // Submit form
            const formData = new FormData(form);
            grecaptcha.ready(() => {
                grecaptcha.execute(document.getElementById("recaptcha").value, {
                    action: 'submit'
                }).then(token => {
                    formData.append('gRecaptchaResponse', token);
                    fetch(form.action, {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.status) {
                            // Success message
                            showMessage('Candidatura enviada com sucesso! Entraremos em contato em breve.', 'success');
                            form.reset();
        
                            // Reset file label
                            const fileLabel = fileInput.nextElementSibling;
                            if (fileLabel && fileLabel.classList.contains('form-help')) {
                                fileLabel.textContent = 'Formatos aceitos: PDF, DOC, DOCX (máx. 5MB)';
                                fileLabel.style.color = '#666';
                            }
                        } else {
                            showMessage(data.message || 'Erro ao enviar candidatura. Tente novamente.', 'error');
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        showMessage('Erro ao enviar candidatura. Tente novamente.', 'error');
                    })
                    .finally(() => {
                        // Reset button state
                        submitButton.disabled = false;
                        submitButton.textContent = 'Enviar candidatura';
                        submitButton.style.opacity = '1';
                    });
                });
            });

        });

        // Real-time validation
        const inputs = form.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
            input.addEventListener('blur', function() {
                if (this.hasAttribute('required') && !this.value.trim()) {
                    this.style.borderColor = '#dc3545';
                } else {
                    this.style.borderColor = '#e1e5e9';
                }
            });

            input.addEventListener('input', function() {
                if (this.style.borderColor === 'rgb(220, 53, 69)') {
                    this.style.borderColor = '#e1e5e9';
                    const errorMsg = this.parentNode.querySelector('.error-message');
                    if (errorMsg) {
                        errorMsg.remove();
                    }
                }
            });
        });
    }

    // Message display function
    function showMessage(message, type) {
        // Remove existing messages
        const existingMessages = document.querySelectorAll('.form-message');
        existingMessages.forEach(msg => msg.remove());

        // Create new message
        const messageDiv = document.createElement('div');
        messageDiv.className = `form-message form-message--${type}`;
        messageDiv.style.cssText = `
            padding: 15px;
            border-radius: 8px;
            margin: 20px 0;
            font-weight: 500;
            text-align: center;
        `;

        if (type === 'success') {
            messageDiv.style.backgroundColor = '#d4edda';
            messageDiv.style.color = '#155724';
            messageDiv.style.border = '1px solid #c3e6cb';
        } else {
            messageDiv.style.backgroundColor = '#f8d7da';
            messageDiv.style.color = '#721c24';
            messageDiv.style.border = '1px solid #f5c6cb';
        }

        messageDiv.textContent = message;

        // Insert message before form
        form.parentNode.insertBefore(messageDiv, form);

        // Auto-remove success messages after 5 seconds
        if (type === 'success') {
            setTimeout(() => {
                messageDiv.remove();
            }, 5000);
        }
    }

    // Phone number formatting
    const phoneField = document.getElementById('phone');
    if (phoneField) {
        phoneField.addEventListener('input', function(e) {
            let value = e.target.value.replace(/\D/g, '');

            if (value.length > 0) {
                if (value.length <= 2) {
                    value = `(${value}`;
                } else if (value.length <= 6) {
                    value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
                } else if (value.length <= 10) {
                    value = `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6)}`;
                } else {
                    value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
                }
            }

            e.target.value = value;
        });
    }

    // Smooth scroll for anchor links
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    function modal() {
    const cards = document.querySelectorAll('[data-url]');

    cards.forEach(card => {
        card.addEventListener('click', function (e) {
            e.preventDefault();

            const url = this.dataset.url;
            const targetModal = document.getElementById('modalVagas'); // seu modal

            if (!targetModal || !url) return;

            // Carrega conteúdo via fetch
            fetch(url)
                .then(response => response.text())
                .then(html => {
                    const modalContent = targetModal.querySelector('#modalDescricao');
                    if (modalContent) modalContent.innerHTML = html;

                    openModal(targetModal);
                    setupCandidatarBtn(targetModal);
                })
                .catch(err => console.error('Erro ao carregar o modal:', err));
        });
    });

    function openModal(modal) {
        modal.classList.add('show');
        modal.style.display = 'flex';
        modal.setAttribute('tabindex', '1');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        void modal.offsetWidth;
        modal.classList.add('fade');

        // Fecha no botão
        const btnClose = modal.querySelector('[data-bs-dismiss="modal"]');
        if (btnClose) btnClose.addEventListener('click', () => closeModal(modal));

        // Fecha ao clicar fora
        modal.addEventListener('click', e => {
            if (e.target === modal) closeModal(modal);
        });
    }

    function closeModal(modal) {
        modal.classList.remove('fade');
        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('tabindex', '-1');

        setTimeout(() => {
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }, 150);
    }

    function setupCandidatarBtn(modal) {
        const candidatarBtn = modal.querySelector('.js-candidatar-vaga');
        if (!candidatarBtn) return;

        candidatarBtn.addEventListener('click', function(e) {
            e.preventDefault();

            const vagaTitulo = this.dataset.vagaTitulo;

            closeModal(modal);

            const vagaSelect = document.getElementById('area');
            if (vagaSelect) {
                let option = vagaSelect.querySelector(`option[value="${vagaTitulo}"]`);
                if (!option) {
                    option = document.createElement('option');
                    option.value = vagaTitulo;
                    option.textContent = vagaTitulo;
                    vagaSelect.appendChild(option);
                }
                vagaSelect.value = vagaTitulo;
            }

            setTimeout(() => {
                const formulario = document.querySelector('.form-vagas');
                if (formulario) formulario.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
        });
    }
}


});
